import React from "react";
import { useInView } from "react-intersection-observer";
import { InstagramIcon, LinkedinIcon, BehanceIcon } from "../../assets/socials";
import "./about.css";

const About = () => {
  const { ref: headingRef, inView: headingInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: textRef, inView: textInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: iconsRef, inView: iconsInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section
      id="about"
      className="container about d-flex align-items-center flex-column justify-content-center"
    >
      <div className="col-12 d-flex flex-column align-items-center justify-content-center">
        <h1
          ref={headingRef}
          className={`${
            headingInView ? "slide-in-left" : "slide-in-left-hidden"
          }`}
        >
          About me
        </h1>
        <p
          ref={textRef}
          className={`text-center mt-2 ${
            textInView ? "fade-in" : "fade-in-hidden"
          }`}
        >
          I'm a Motion Designer with 10 years of experience, focused on creating
          eye-catching 2D/3D animations and dynamic promo videos that bring
          ideas to life. I love turning concepts into powerful visual stories -
          whether it’s for brands, products, or social media. I’ve worked across
          various industries, including Web3, where I created animations, social
          content, and branding for blockchain startups and NFT projects. I also
          have a solid background in UI/UX, product design, and social media
          branding. I'm all about clean visuals, smart design, and making every
          project feel fresh and engaging.
        </p>
        <div
          ref={iconsRef}
          className={`row  d-flex align-items-center justify-content-center social-icons-container ${
            iconsInView ? "fade-in" : "fade-in-hidden"
          }`}
        >
          <a
            href="https://www.linkedin.com/in/mirza-kurbegovic"
            target="_blank"
            className="col-4  d-flex justify-content-center"
          >
            <img src={LinkedinIcon} alt="linkedin" className="social-icon" />
          </a>
          <a
            href="https://www.instagram.com/mirzgfx"
            target="_blank"
            className="col-4  d-flex justify-content-center"
          >
            <img src={InstagramIcon} alt="instagram" className="social-icon" />
          </a>
          {/* <a
            href="https://www.behance.net/mirzakurbegovic"
            target="_blank"
            className="col-4 d-flex justify-content-center"
          >
            <img src={BehanceIcon} alt="behance" className="social-icon" />
          </a> */}
        </div>
      </div>
    </section>
  );
};

export default About;
